import * as React from 'react';
import { OrderedSet } from 'immutable';
import { Editor, Mark } from 'slate';
import { RenderBlockProps, RenderInlineProps, RenderMarkProps } from 'slate-react';

import { BLOCK_TYPES, INLINE_TYPES, MARK_TYPES, TEXT_DECORATION } from './constants';
import { getColor } from './marks';
import { linkClassName } from '../../../../containers/Editor/constants';

// tslint:disable-next-line no-any
export const renderBlock = (props: RenderBlockProps, editor: Editor, next: () => any): any => {
	const { node: { type, data }, attributes, children } = props;

	if (type === BLOCK_TYPES.p) {
		return (
			<p
				{...attributes}
				style={data.get('style')}
				className={data.get('className')}
			>
				{children}
			</p>
		);
	}

	if (type === BLOCK_TYPES.h1) {
		return (
			<h1
				{...attributes}
				style={data.get('style')}
				className={data.get('className')}
			>
				{children}
			</h1>
		);
	}

	if (type === BLOCK_TYPES.h2) {
		return (
			<h2
				{...attributes}
				style={data.get('style')}
				className={data.get('className')}
			>
				{children}
			</h2>
		);
	}

	if (type === BLOCK_TYPES.h3) {
		return (
			<h3
				{...attributes}
				style={data.get('style')}
				className={data.get('className')}
			>
				{children}
			</h3>
		);
	}

	if (type === BLOCK_TYPES.h4) {
		return (
			<h4
				{...attributes}
				style={data.get('style')}
				className={data.get('className')}
			>
				{children}
			</h4>
		);
	}

	if (type === BLOCK_TYPES.h5) {
		return (
			<h5
				{...attributes}
				style={data.get('style')}
				className={data.get('className')}
			>
				{children}
			</h5>
		);
	}

	if (type === BLOCK_TYPES.h6) {
		return (
			<h6
				{...attributes}
				style={data.get('style')}
				className={data.get('className')}
			>
				{children}
			</h6>
		);
	}

	if (type === BLOCK_TYPES.ul) {
		return (
			<ul
				{...attributes}
				style={data.get('style')}
				className={data.get('className')}
			>
				{children}
			</ul>
		);
	}

	if (type === BLOCK_TYPES.ol) {
		return (
			<ol
				{...attributes}
				style={data.get('style')}
				className={data.get('className')}
			>
				{children}
			</ol>
		);
	}

	if (type === BLOCK_TYPES.li) {
		return (
			<li
				{...attributes}
				style={data.get('style')}
				className={data.get('className')}
			>
				{children}
			</li>
		);
	}

	if (type === BLOCK_TYPES.section) {
		return (
			<section
				{...attributes}
				style={data.get('style')}
				className={data.get('className')}
				aria-label={data.get('aria-label')}
			>
				{children}
			</section>
		);
	}

	if (type === BLOCK_TYPES.aside) {
		return (
			<aside
				{...attributes}
				style={data.get('style')}
				className={data.get('className')}
				aria-label={data.get('aria-label')}
			>
				{children}
			</aside>
		);
	}

	return next();
};

// tslint:disable-next-line no-any
export const renderInline = (props: RenderInlineProps, editor: Editor, next: () => any): any => {
	const { node: { type, data, text, nodes }, attributes, children } = props;

	if (type === INLINE_TYPES.a) {
		// We have to remove link when all text for link was deleted
		if (!text) {
			return children;
		}

		const hasColorMarks = nodes.every((node) => {
			if (!node) {
				return false;
			}

			const color = getColor(node.marks as OrderedSet<Mark>);
			return !!color;
		});

		// this style is used when no color style set in link text from initial html
		const style = hasColorMarks ? undefined : { textDecoration: TEXT_DECORATION.UNDERLINE };

		return (
			<a
				{...attributes}
				href={data.get('href')}
				data-action={data.get('action')}
				className={data.get('className') || linkClassName}
				style={style}
			>
				{children}
			</a>
		);
	}

	return next();
};

export const renderMark = ({ mark, marks, attributes, children: leaf }: RenderMarkProps): React.ReactNode => {
	const isFirstMark = mark === marks.first();

	if (!isFirstMark) {
		return;
	}

	const orderedMarks: Mark[] = [];
	MARK_TYPES.forEach((markType) => {
		const mark = marks.find(({ type }: Mark) => type === markType);
		if (mark) {
			orderedMarks.unshift(mark);
		}
	});

	return orderedMarks.reduce((children, mark) => (
		<span
			{...attributes}
			className={mark.data.get('className')}
			style={mark.data.get('style')}
		>
			{children}
		</span>
	), leaf);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/RichTextEditor/helpers/renderers.tsx